'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'traffic-light-stop';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f63a';
var svgPathData = ['M32 32l0 352c0 70.7 57.3 128 128 128s128-57.3 128-128l0-352c0-17.7-14.3-32-32-32L64 0C46.3 0 32 14.3 32 32zm184 80a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0 144a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM104 400c0-30.9 25.1-56 56-56s56 25.1 56 56-25.1 56-56 56-56-25.1-56-56z', 'M64 0C46.3 0 32 14.3 32 32l0 352c0 70.7 57.3 128 128 128s128-57.3 128-128l0-352c0-17.7-14.3-32-32-32L64 0zM0 32C0-3.3 28.7-32 64-32l192 0c35.3 0 64 28.7 64 64l0 352c0 88.4-71.6 160-160 160S0 472.4 0 384L0 32zM136 400c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm-32 0c0-30.9 25.1-56 56-56s56 25.1 56 56-25.1 56-56 56-56-25.1-56-56zm56-168a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-144a56 56 0 1 1 0-112 56 56 0 1 1 0 112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrafficLightStop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;